import { Colors } from "@/enums/Colors";
import { Box, styled, SxProps } from "@mui/material";

function DataRoomFileListIcon({ img, sxContainer }: { img: JSX.Element; sxContainer?: SxProps }) {
  return <MainContainer sx={sxContainer}>{img}</MainContainer>;
}

const MainContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: Colors.DARK_GREY_3E3E3E,
  borderRadius: "0.5rem",
  gap: "0.5rem",
  // Responsive sizing for better mobile touch targets
  width: "2.75rem",
  height: "2.75rem",
  padding: "0.625rem",
  [theme.breakpoints.up("sm")]: {
    width: "2.5rem",
    height: "2.5rem",
    padding: "0.5rem",
  },
  // Ensure minimum touch target size on mobile
  minWidth: "44px",
  minHeight: "44px",
}));

export default DataRoomFileListIcon;
